export const datasProjects = {
  /* MAPALYTICS */
  'mapalytics': {
    id: 'hjtryjytrsw',

    type: 'PROJECT PORTFOLIO',

    title: 'Mapalytics',

    description:
      'Mapalytics is a geomarketing web platform that combines data and public sources to help companies find new leads and sales opportunities anywhere in Brazil.',

    cover: 'mapalytics/mapalytics.jpg',

    thumb: {
      img: 'mapalytics/thumb-mapalytics.jpg',
      alt: 'Mapalytics website'
    },

    links: {
      online: 'https://mapalytics.com.br/',
      github: ''
    },

    meta: [
      {
        icon: '▣',
        label: 'March, 2024'
      },
      {
        icon: '◇',
        label: 'Next.js'
      },
      {
        icon: '▰',
        label: 'JavaScript'
      },
      {
        icon: '◎',
        label: 'HTML / CSS'
      }
    ],

    /*
     * O projeto antigo não possuía informações específicas
     * separadas entre desafio e solução.
     */

    details: [
      {
        title: 'YEAR',
        values: [
          'March, 2024'
        ]
      },
      {
        title: 'DEVELOPMENT KIT',
        values: [
          'Next.js',
          'HTML',
          'CSS',
          'JavaScript'
        ]
      }
    ],

    gallery: [
      { type: 'image', src: 'mapalytics/mapalytics.jpg' }
    ],

    technologies: [
      {
        name: 'Next.js',
        short: 'N',
        type: 'next'
      },
      {
        name: 'HTML',
        short: '5',
        type: 'html'
      },
      {
        name: 'CSS',
        short: '3',
        type: 'css'
      },
      {
        name: 'JavaScript',
        short: 'JS',
        type: 'javascript'
      }
    ],

    previous: 'data-machina',

    next: 'tre-communication'
  },

  /* TRE */
  'tre-communication': {
    id: 'mp2rewfwbiuz',

    type: 'PROJECT PORTFOLIO',

    title: 'Tre Communication',

    description:
      'Tre Communication is a design studio founded in 1990 by designer Kito Castanha. In 2023, Tre celebrated its 33rd anniversary, and a new website was launched to mark the occasion.',

    cover: 'tre/mobile-tre-studio-design.jpg',

    thumb: {
      img: 'tre/thumb-website-tre-studio-design.jpg',
      alt: 'One-page Tre Designs website | Vue.js HTML CSS'
    },

    links: {
      online: 'https://tre.art.br/',
      github: 'https://github.com/MateusDuraessantos/tre'
    },

    meta: [
      {
        icon: '▣',
        label: 'February, 2023'
      },
      {
        icon: '◇',
        label: 'UX/UI'
      },
      {
        icon: '▰',
        label: 'Front-end'
      },
      {
        icon: '◎',
        label: 'Figma'
      }
    ],

    /*
     * O projeto antigo não possuía informações específicas
     * separadas entre desafio e solução.
     */

    details: [
      {
        title: 'YEAR',
        values: [
          'February, 2023'
        ]
      },
      {
        title: 'MY ROLE',
        values: [
          'Design: All of Tre\'s branding was analyzed and, following the brief, I created a new UX/UI landing page interface. The project was built following design thinking methodologies and prototyped in Figma.',
          'Development: I developed the entire front-end structure, used GitHub to manage and version the code, and finally hosted it on Tre\'s domain to go live.'
        ]
      },
      {
        title: 'DEVELOPMENT KIT',
        values: [
          'Vue.js 2',
          'JavaScript',
          'HTML',
          'CSS',
          'Firebase Hosting',
          'GitHub',
          'Element Plus'
        ]
      }
    ],

    gallery: [
      { type: 'image', src: 'tre/mobile-tre-studio-design.jpg' },
      { type: 'image', src: 'tre/studio-tre.jpg' },
      { type: 'image', src: 'tre/website-tre-studio-design.jpg' }
    ],

    technologies: [
      {
        name: 'Vue.js 2',
        short: 'V',
        type: 'vue'
      },
      {
        name: 'JavaScript',
        short: 'JS',
        type: 'javascript'
      },
      {
        name: 'HTML',
        short: '5',
        type: 'html'
      },
      {
        name: 'CSS',
        short: '3',
        type: 'css'
      },
      {
        name: 'Firebase Hosting',
        short: '▲',
        type: 'firebase'
      },
      {
        name: 'GitHub',
        short: 'GH',
        type: 'github'
      },
      {
        name: 'Element Plus',
        short: 'EP',
        type: 'element'
      }
    ],

    previous: 'mapalytics',

    next: 'mackenzie-design'
  },

  // TCC
  'mackenzie-design': {
    id: 'dfrejmwopqfremn',

    type: 'FINAL DEGREE PROJECT',

    title: 'Design course at Universidade Presbiteriana Mackenzie',

    description:
      'This project is a redesign of the website for the undergraduate Design course at Universidade Presbiteriana Mackenzie.',

    cover: 'tcc/webiste_mackenzie_curso_de_design.jpg',

    thumb: {
      img: 'tcc/thumb-pagina_inicial_do_projeto.jpg',
      alt: 'Final project website - Mackenzie'
    },

    links: {
      online: 'https://mackenzie-tcc.web.app/#/',
      github: 'https://github.com/MateusDuraessantos/TCC'
    },

    meta: [
      {
        icon: '▣',
        label: 'September, 2022'
      },
      {
        icon: '◇',
        label: 'UX/UI'
      },
      {
        icon: '▰',
        label: 'Front-end'
      },
      {
        icon: '◎',
        label: 'Vue.js 2'
      }
    ],

    /*
     * O projeto antigo não possuía informações específicas
     * separadas entre desafio e solução.
     */

    details: [
      {
        title: 'YEAR',
        values: [
          'September, 2022'
        ]
      },
      {
        title: 'MY ROLE',
        values: [
          'Design process: Two main methodologies were used to guide the project: HCD (Human Centered Design) and Jesse James Garrett\'s 5 elements of UX design, addressing strategy, scope, structure, skeleton, and surface.',
          'Development: I built the project using Vue.js 2, JavaScript, HTML, and CSS. I handled deployment through Firebase Hosting, managed version control on GitHub, and used Element Plus for some interface components.'
        ]
      },
      {
        title: 'DEVELOPMENT',
        values: [
          'Vue.js 2',
          'JavaScript',
          'HTML',
          'CSS',
          'Firebase Hosting',
          'GitHub',
          'Element Plus'
        ]
      }
    ],

    gallery: [
      { type: 'image', src: 'tcc/webiste_mackenzie_curso_de_design.jpg' },
      { type: 'image', src: 'tcc/pagina_inicial_do_projeto.jpg' },
      { type: 'image', src: 'tcc/arvore_de_navegacao_proposta.jpg' }
    ],

    technologies: [
      {
        name: 'Vue.js 2',
        short: 'V',
        type: 'vue'
      },
      {
        name: 'JavaScript',
        short: 'JS',
        type: 'javascript'
      },
      {
        name: 'HTML',
        short: '5',
        type: 'html'
      },
      {
        name: 'CSS',
        short: '3',
        type: 'css'
      },
      {
        name: 'Firebase Hosting',
        short: '▲',
        type: 'firebase'
      },
      {
        name: 'GitHub',
        short: 'GH',
        type: 'github'
      },
      {
        name: 'Element Plus',
        short: 'EP',
        type: 'element'
      }
    ],

    previous: 'tre-communication',

    next: 'mapalytics-distance-calculator'
  },

  /* CALCULADORA DE KM */
  'mapalytics-distance-calculator': {
    id: 'usususuuss',

    type: 'PROJECT PORTFOLIO',

    title: 'Mapalytics - Distance Calculator',

    description:
      'The Distance Calculator is a tool from a Mapalytics product, by the startup Data Machina, focused on helping companies analyze their own territorial reach. The tool can receive multiple inputs of origins and destinations of different types and calculate the distances between the selected points all at once.',

    /*
     * O primeiro arquivo do projeto antigo é um MP4.
     * Como o hero atual utiliza <img>, foi utilizada a imagem PNG
     * já existente no projeto como capa.
     */
    cover: 'calculadora/calculadora.png',

    thumb: {
      img: 'calculadora/thumb.png',
      alt: 'Mapalytics Data Machina'
    },

    links: {
      online: 'https://mapalytics.com.br/',
      github: ''
    },

    meta: [
      {
        icon: '▣',
        label: 'September, 2025'
      },
      {
        icon: '◇',
        label: 'Design'
      },
      {
        icon: '▰',
        label: 'Frontend'
      },
      {
        icon: '◎',
        label: 'Mapbox GL'
      }
    ],

    /*
     * O projeto antigo não possuía informações específicas
     * separadas entre desafio e solução.
     */

    details: [
      {
        title: 'YEAR',
        values: [
          'September, 2025'
        ]
      },
      {
        title: 'MY ROLE',
        values: [
          'Frontend - I created the entire frontend architecture of the tool using Vue.js 2, HTML, CSS, and JavaScript. I implemented the interactive map features with Mapbox GL and integrated all backend endpoints through Firebase’s httpsCallable functions.',
          'Design - In addition to development, I actively contributed to the interface design and user experience. I applied Jesse James Garrett’s “Five Elements of User Experience” methodology to create a clear and efficient interface.'
        ]
      }
    ],

    gallery: [
      { type: 'video', src: 'calculadora/origins_calculator.mp4', mimeType: 'video/mp4', alt: 'Mapalytics Data Machina' },
      { type: 'image', src: 'calculadora/selected_alternatives.png' },
      // { type: 'image', src: 'calculadora/calculadora.png' },
      { type: 'video', src: 'calculadora/alternatives_selection.mp4', mimeType: 'video/mp4', alt: 'Mapalytics Data Machina' }
    ],

    technologies: [
      {
        name: 'Vue.js 2',
        short: 'V',
        type: 'vue'
      },
      {
        name: 'JavaScript',
        short: 'JS',
        type: 'javascript'
      },
      {
        name: 'HTML',
        short: '5',
        type: 'html'
      },
      {
        name: 'CSS',
        short: '3',
        type: 'css'
      },
      {
        name: 'Mapbox GL',
        short: 'M',
        type: 'mapbox'
      },
      {
        name: 'Firebase',
        short: '▲',
        type: 'firebase'
      }
    ],

    previous: 'mackenzie-design',

    next: 'design-system-data-machina'
  },

  /* DESIGN SYSTEM */
  'design-system-data-machina': {
    id: '07665849',

    type: 'PROJECT PORTFOLIO',

    title: 'Design System | Data Machina',

    description:
      'The Data Machina Design System is a unified visual and functional framework that defines the foundations and components of the brand’s digital products. Built to ensure consistency, scalability, and efficiency, it brings together principles of design, color, typography, iconography, and interaction patterns into a cohesive ecosystem.',

    cover: 'design_system/design_system.png',

    thumb: {
      img: 'design_system/thumb.png',
      alt: 'Design System preview'
    },

    links: {
      online: 'https://design-system-dm.web.app',
      github: 'https://github.com/gustavoemmanoel/DM-Design-System/tree/main'
    },

    meta: [
      {
        icon: '▣',
        label: 'Aug, 2023'
      },
      {
        icon: '◇',
        label: 'Design System'
      },
      {
        icon: '▰',
        label: 'Frontend'
      },
      {
        icon: '◎',
        label: 'Element Plus'
      }
    ],

    /*
     * O projeto antigo não possuía informações específicas
     * separadas entre desafio e solução.
     */

    details: [
      {
        title: 'YEAR',
        values: [
          'Aug, 2023'
        ]
      },
      {
        title: 'MY ROLE',
        values: [
          'I was responsible for the entire frontend development of the project. The website was built with Vue.js 2 and Element Plus, hosted through Firebase Hosting. My main goal was to customize and extend all Element Plus components to align them with Data Machina’s visual identity and design principles, ensuring a cohesive and branded user experience across all interfaces.'
        ]
      },
      {
        title: 'DEVELOPMENT KIT',
        values: [
          'Vue.js 2',
          'JavaScript',
          'HTML',
          'CSS',
          'Firebase Hosting',
          'Element Plus',
          'GitHub'
        ]
      }
    ],

    gallery: [
      { type: 'image', src: 'design_system/design_system.png' },
      { type: 'image', src: 'design_system/website_design_system.png' },
      { type: 'image', src: 'design_system/design_system_mobile_instagram.jpg' }
    ],

    technologies: [
      {
        name: 'Vue.js 2',
        short: 'V',
        type: 'vue'
      },
      {
        name: 'JavaScript',
        short: 'JS',
        type: 'javascript'
      },
      {
        name: 'HTML',
        short: '5',
        type: 'html'
      },
      {
        name: 'CSS',
        short: '3',
        type: 'css'
      },
      {
        name: 'Firebase Hosting',
        short: '▲',
        type: 'firebase'
      },
      {
        name: 'Element Plus',
        short: 'EP',
        type: 'element'
      },
      {
        name: 'GitHub',
        short: 'GH',
        type: 'github'
      }
    ],

    previous: 'mapalytics-distance-calculator',

    next: 'teclakey'
  },

  // TECLAKEY
  'teclakey': {
    id: 'zmgvpregujirew',

    type: 'PROJECT PORTFOLIO',

    title: 'TeclaKey',

    description:
      'TeclaKey is a creative design studio focused on developing customized websites and digital identities. The website was built to clearly communicate the studio\'s values — transparency, innovation, and empowerment — while providing a simple user experience.',

    cover: 'teclakey/mockup-site-studios-design-teclakey.jpg',

    thumb: {
      img: 'teclakey/thumb-teclakey-webiste-de-design.jpg',
      alt: 'TeclaKey website - UX/UI - Firebase'
    },

    links: {
      online: 'https://tecla-key.web.app/',
      github: 'https://github.com/MateusDuraessantos/teclakeygit'
    },

    meta: [
      {
        icon: '▣',
        label: 'May, 2022'
      },
      {
        icon: '◇',
        label: 'Design'
      },
      {
        icon: '▰',
        label: 'Front-end'
      },
      {
        icon: '◎',
        label: 'SEO'
      }
    ],
    
    /*
     * O projeto antigo não possuía informações específicas
     * separadas entre desafio e solução.
     */

    details: [
      {
        title: 'YEAR',
        values: [
          'May, 2022'
        ]
      },
      {
        title: 'MY ROLE',
        values: [
          'Design: While developing the website in collaboration with a three-person team, I coordinated the visual identity design.',
          'Development: I was responsible for the front-end development, responsive layout, domain implementation, and web content optimization (SEO).'
        ]
      }
    ],

    gallery: [
      { type: 'image', src: 'teclakey/mockup-site-studios-design-teclakey.jpg' },
      { type: 'image', src: 'teclakey/teclakey-webiste-de-design.jpg' },
      { type: 'image', src: 'teclakey/teclakey.gif' }
    ],

    /*
     * O projeto antigo não informava uma lista de tecnologias.
     */
    technologies: [],

    previous: 'design-system-data-machina',

    next: 'data-machina'
  },

  /* DATA MACHINA */
  'data-machina': {
    id: 'gtrnieogvreoifg',

    type: 'PROJECT PORTFOLIO',

    title: 'Data Machina',

    description:
      'In this project, with the design (for desktop) and content already developed beforehand by other collaborators, I was responsible for building the entire HTML and CSS structure and making it responsive for mobile devices.',

    cover: 'datamachina/datamachina.jpg',

    thumb: {
      img: 'datamachina/thumb-datamachina_website_onepage.jpg',
      alt: 'Data Machina / Frontend project with HTML and CSS'
    },

    links: {
      online: 'https://data-machina.web.app/',
      github: 'https://github.com/MateusDuraessantos/site-datamachina-portf'
    },

    meta: [
      {
        icon: '▣',
        label: 'December, 2021'
      },
      {
        icon: '◇',
        label: 'HTML'
      },
      {
        icon: '▰',
        label: 'CSS'
      },
      {
        icon: '◎',
        label: 'Responsive'
      }
    ],

    /*
     * O projeto antigo não possuía informações específicas
     * separadas entre desafio e solução.
     */

    details: [
      {
        title: 'YEAR',
        values: [
          'December, 2021'
        ]
      },
      {
        title: 'MY ROLE',
        values: [
          'I was responsible for building the entire HTML and CSS structure and making it responsive for mobile devices.'
        ]
      },
      {
        title: 'DEVELOPMENT STACK',
        values: [
          'Vue.js 2',
          'JavaScript',
          'HTML',
          'CSS',
          'GitHub',
          'Element Plus'
        ]
      }
    ],

    gallery: [
      { type: 'image', src: 'datamachina/datamachina.jpg' },
      { type: 'image', src: 'datamachina/datamachina_website_onepage.jpg' }
    ],

    technologies: [
      {
        name: 'Vue.js 2',
        short: 'V',
        type: 'vue'
      },
      {
        name: 'JavaScript',
        short: 'JS',
        type: 'javascript'
      },
      {
        name: 'HTML',
        short: '5',
        type: 'html'
      },
      {
        name: 'CSS',
        short: '3',
        type: 'css'
      },
      {
        name: 'GitHub',
        short: 'GH',
        type: 'github'
      },
      {
        name: 'Element Plus',
        short: 'EP',
        type: 'element'
      }
    ],

    previous: 'teclakey',

    next: 'mapalytics'
  }
}
